import { render, staticRenderFns } from "./CommercePartners.vue?vue&type=template&id=2a428693&"
import script from "./CommercePartners.vue?vue&type=script&lang=ts&"
export * from "./CommercePartners.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports